import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CustomSearchComponent } from '../../../../shared/components/custom-search/custom-search';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CustomButtonComponent } from '../../../../shared/components/custom-button/custom-button';
import { MenuSystemService } from '../../services/menu-system-service';
import { LoaderService } from '../../../../core/services/loader/loader-service';
import { CommonModule } from '@angular/common';
import { Menu } from '../../models/Menu';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {
  CustomModalComponent,
  ModalButton,
} from '../../../../shared/components/custom-modal/custom-modal';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputCustom } from '../../../../shared/components/input-custom/input-custom';
import { TableUtil } from '../../../../shared/utils/tableUtil';
import { ToastService } from '../../../../core/services/toast/toast-service';
import { CustomTooltipComponent } from '../../../../shared/components/custom-tooltip/custom-tooltip';

@Component({
  selector: 'app-menu-system-config-page',
  imports: [
    MatCardModule,
    CommonModule,
    MatTableModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    CustomSearchComponent,
    CustomButtonComponent,
    CustomModalComponent,
    InputCustom,
    ReactiveFormsModule,
    CustomTooltipComponent,
    MatSortModule,
  ],
  templateUrl: './menu-system-config-page.html',
  styleUrl: './menu-system-config-page.css',
})
export class MenuSystemConfigPage {
  public menus: Menu[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort?: MatSort;
  submitted = false;
  dataSource: any;
  searchText: string = '';
  displayedColumns: string[] = ['codigoMenu', 'titulo', 'ruta', 'symbol'];
  isOpenModal: boolean = false;

  constructor(
    private router: Router,
    private menuSystemService: MenuSystemService,
    private loaderService: LoaderService,
    private paginatorIntl: MatPaginatorIntl,
    private toastService: ToastService
  ) {
    this.paginatorIntl.itemsPerPageLabel = 'Filas por página:';
    this.paginatorIntl.lastPageLabel = 'Última página';
    this.paginatorIntl.firstPageLabel = 'Primera página';
    this.paginatorIntl.nextPageLabel = 'Página siguiente';
    this.paginatorIntl.previousPageLabel = 'Página anterior';

    this.paginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
    this.paginatorIntl.changes.next();
  }

  ngOnInit() {
    this.getAllMenus();
  }

  navigateToMenu() {
    this.router.navigate(['/menu']);
  }

  getAllMenus() {
    this.loaderService.showLoader();
    this.menuSystemService.findAll().subscribe({
      next: (res) => {
        this.menus = res;
        this.dataSource = new MatTableDataSource<Menu>(this.menus);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.applyFilter(this.searchText);
        this.loaderService.hideLoader();
      },
      error: (err) => {
        console.error('Error fetching menus:', err);
        this.loaderService.hideLoader();
      },
    });
  }


  onSearchKeyup(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    this.searchText = target.value;
    this.applyFilter(this.searchText);
  }

  applyFilter(searchText: string) {
    this.dataSource.filter = searchText.trim().toLowerCase();
  }


  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.editMode = false;
    this.submitted = false;
    this.menuForm.reset();
  }

  editMode: boolean = false;
  editMenuButtons: ModalButton[] = [
    {
      text: 'Guardar cambios',
      variant: 'primary',
      variantCancel:'info',
      action: 'update',
    },
  ];

  addMenuButtons: ModalButton[] = [
    {
      text: 'Agregar',
      variant: 'primary',
      variantCancel:'info',
      action: 'save',
    },
  ];

  openEditModal(menu: Menu) {
    this.isOpenModal = true;
    this.editMode = true;
    this.menuForm.patchValue({
      codigoMenu: menu.codigoMenu,
      titulo: menu.titulo,
      ruta: menu.ruta,
    });
  }

  exportTable(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    let datos: any[] = [];
    this.menus.forEach((element) => {
      let data = {
        'Codigo Menu': element.codigoMenu,
        Nombre: element.titulo,
        Ruta: element.ruta,
      };
      datos.push(data);
    });
    TableUtil.exportToExcelModel(datos);
  }

  //formulario
  menuForm = new FormGroup({
    codigoMenu: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    titulo: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    ruta: new FormControl('', [Validators.required, Validators.maxLength(300)]),
  });

  ngAfterViewInit() {
    this.menuForm.statusChanges.subscribe(() => {
      if (this.editMode) {
        this.editMenuButtons = [
          {
            text: 'Guardar cambios',
            variant: 'primary',
            action: 'update',

          },
        ];
      } else {
        this.addMenuButtons = [
          {
            text: 'Agregar',
            variant: 'primary',
            action: 'save',
          },
        ];
      }
    });
  }

  submitMenuForm() {
    this.submitted = true;
    if (this.menuForm.invalid) {
      return;
    }
    this.loaderService.showLoader();

    const menuData: Menu = {
      codigoMenu: this.menuForm.value.codigoMenu!.trim(),
      titulo: this.menuForm.value.titulo!.trim(),
      ruta: this.menuForm.value.ruta!.trim(),
    };

    if (this.editMode) {
      this.menuSystemService.update(menuData).subscribe({
        next: (res) => {
          this.loaderService.hideLoader();
          this.getAllMenus();
          this.toastService.showToast(
            'Menú actualizado exitosamente.',
            'success'
          );
          this.closeModal();
        },
        error: (err) => {
          this.loaderService.hideLoader();
          console.error('Error updating menu:', err);
          this.toastService.showToast('Error al actualizar el menú. ', 'error');
          this.closeModal();
        },
      });
    } else {
      this.menuSystemService.create(menuData).subscribe({
        next: (res) => {
          this.loaderService.hideLoader();
          this.getAllMenus();
          this.toastService.showToast('Menú creado exitosamente.', 'success');
          this.closeModal();
        },
        error: (err) => {
          this.loaderService.hideLoader();
          console.error('Error creating menu:', err);
          if(err.status === 409) {
            this.toastService.showToast('El código ya existe. ', 'error');
          }else {
            this.toastService.showToast('Error al crear el menú. ', 'error');
          }
          this.closeModal();
        },
      });
    }
    this.loaderService.hideLoader();
  }

  get codigoMenu() {
    return this.menuForm.get('codigoMenu')!;
  }
  get titulo() {
    return this.menuForm.get('titulo')!;
  }
  get ruta() {
    return this.menuForm.get('ruta')!;
  }
}
